import type { CatalogCategorySlug } from '@/routes/routeRegistry';
import { routePaths } from '@/routes/routeRegistry';

export type AdminCatalogSectionId =
  | 'co2-natural-refrigerant'
  | 'energy-solution'
  | 'mechanical-hvac'
  | 'refrigeration-system';

interface AdminCatalogSectionLink {
  categorySlug: CatalogCategorySlug;
  id: string;
  label: string;
  to: string;
}

const createSectionPath = (categorySlug: CatalogCategorySlug, sectionId: string) => {
  return `${routePaths.adminCatalogItems(categorySlug)}?section=${sectionId}`;
};

export const adminCatalogSectionLinks: AdminCatalogSectionLink[] = [
  {
    categorySlug: 'co2-natural-refrigerant',
    id: 'co2-natural-refrigerant',
    label: 'CO₂ 자연냉매',
    to: createSectionPath('co2-natural-refrigerant', 'co2-natural-refrigerant'),
  },
  {
    categorySlug: 'refrigeration-system',
    id: 'refrigeration-system',
    label: '냉동·냉장 시스템',
    to: createSectionPath('refrigeration-system', 'refrigeration-system'),
  },
  {
    categorySlug: 'energy-solution',
    id: 'energy-solution',
    label: '에너지 솔루션',
    to: createSectionPath('energy-solution', 'energy-solution'),
  },
  {
    categorySlug: 'mechanical-hvac',
    id: 'mechanical-hvac',
    label: '공조 기계설비',
    to: createSectionPath('mechanical-hvac', 'mechanical-hvac'),
  },
];

export const defaultAdminCatalogSectionPath = adminCatalogSectionLinks[0].to;

export const createAdminCatalogSectionLinks = (
  categories: Array<{ label: string; slug: CatalogCategorySlug }>,
) => {
  const links = categories.map((category) => ({
    categorySlug: category.slug,
    id: category.slug,
    label: category.label,
    to: createSectionPath(category.slug, category.slug),
  }));

  return links.length > 0 ? links : adminCatalogSectionLinks;
};

export const getDefaultAdminCatalogSectionPath = (
  categories: Array<{ label: string; slug: CatalogCategorySlug }>,
) => {
  return createAdminCatalogSectionLinks(categories)[0]?.to ?? defaultAdminCatalogSectionPath;
};

export const getAdminCatalogSectionLink = (
  categorySlug: CatalogCategorySlug,
  sectionId: string | null,
) => {
  return adminCatalogSectionLinks.find((link) => {
    return link.categorySlug === categorySlug && link.id === sectionId;
  });
};
